<template>
  <div class="order_detail">
    <nav-bar />
    <search-bar />
    <div class="main fz14" v-if="loading">
      <div class="nav">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item>我的订单</el-breadcrumb-item>
          <el-breadcrumb-item>订单详情</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="info_box">
        <div class="info mb20">
          <div class="fr ac fz12 mt20">
            <div class="center order_list_item">产品信息</div>
            <div class="center order_list_item">产品规格</div>
            <div class="center order_list_item">设备信息</div>
            <div class="center order_list_item">配套工艺</div>
            <div class="center order_list_item">产品价格</div>
            <div class="center order_list_item">数量</div>
            <div class="center order_list_item">商品价格</div>
          </div>
          <el-divider />
          <div class="order-list fz12">
            <div class="order-item mt20">
              <!--                上-->
              <div class="top">
                <span>{{order_detail.create_time}}</span>
                <span class="ml20 grey">订单编号：{{order_detail.order_no}}</span>
                <span class="ml40 blue" v-html="order_state_decide(order_detail)"></span>
              </div>
              <!--                中-->

              <div class="fr middle">
                <!-- 商品信息 -->
                <div class="order">
                  <div
                    class="fr jc ac order_left"
                    v-for="(goods,i) in order_detail.orderGoodsBeans"
                    :key="i"
                  >
                    <div class="fr afs pl10 pr20 pt20 pb20 order_list_item">
                      <el-image class="goods_img fs mr10" :src="goods.goods_img" alt />
                      <p class>{{goods.goods_name}} {{goods.goods_standard_name}}</p>
                    </div>
                    <div class="center order_list_item"> {{ specNameInit(goods) }}</div>
                    <div class="center order_list_item">{{goods.device_id?goods.device_id:'-'}}</div>

                    <div
                      v-if="goods.goods_type==1"
                      @click="onShowSelectCraft(goods.order_goods_id)"
                      class="center cursor order_list_item blue"
                    >{{goods.goods_craft_price}}</div>
                    <div v-if="goods.goods_type==2" class="center cursor order_list_item bule">-</div>

                    <div class="center order_list_item">￥{{goods.goods_price}}</div>
                    <div class="center order_list_item">{{goods.goods_num}}</div>
                    <div class="center order_list_item red">￥{{goods.goods_total_price}}</div>
                  </div>
                </div>
              </div>

              <!--                下-->
            </div>
          </div>
        </div>
        <div class="price_box">
          <div class="price_item fr ac jsb mb20">
            <span class="black">订单总价</span>
            <span class="red bold">￥{{order_detail.order_total_price}}</span>
          </div>

          <div class="price_item fr ac jsb mb20">
            <span>开具发票</span>
            <span class="black">{{order_detail.orderInvoiceBean.invoice_name}}</span>
          </div>
          <!-- 付款比例 -->
          <p class="fz16 bold mt20 mb20">付款方式</p>
          <div class="pay_table">
            <div class="tr fr">
              <div class="th fg fs">款到下单(%)</div>
              <div class="th fg fs">款到发货(%)</div>
              <div class="th fg fs">货到付款(%)</div>
            </div>
            <div class="tr fr">
              <div class="td fg fs">
                <span
                  type="number"
                  style="border-bottom: 1px solid black;width: 50px;text-align: center"
                >{{order_detail.pay_start_proportion}}</span>

                <div></div>
              </div>
              <div class="td fg fs">
                <span
                  style="border-bottom: 1px solid black;width: 50px;text-align: center"
                >{{order_detail.pay_ing_proportion}}</span>

                <div></div>
              </div>
              <div class="td fg fs fr ac jc">
                <span>{{order_detail.pay_end_proportion}}</span>
                <div class="ml20">
                  <span class="blue">
                    <span
                      type="number"
                      style="border-bottom: 1px solid black;width: 50px;text-align: center"
                    >{{order_detail.pay_day}}</span>
                  </span>
                  <el-tooltip placement="top">
                    <div slot="content">
                      货到后须多少天内付款
                      <br />例：30天，货到后须在30天内将剩余的60%付齐。
                    </div>

                    <i class="el-icon-warning-outline red"></i>
                  </el-tooltip>
                </div>
              </div>
            </div>
          </div>
          <el-divider />
          <!-- 收货地址 -->
          <p class="fz16 bold mt20 mb20">收货地址</p>
          <div class="receipt" v-if="order_detail.orderAddressBean">
            <div class="top fr ac">
              <p>{{order_detail.orderAddressBean.address_name}}</p>
              <p class="ml20">{{ this.formatPhone(order_detail.orderAddressBean.address_mobile)}}</p>
            </div>
            <div class="bottom">
              {{order_detail.orderAddressBean.address_province}}
              {{order_detail.orderAddressBean.address_city}}
              {{order_detail.orderAddressBean.address_country}}
              {{order_detail.orderAddressBean.address_detailed}}
            </div>
          </div>
          <!--          合同类型-->
          <p class="fz16 bold mt20 mb20">合同</p>

          <el-divider />
          <!-- 平台合同 -->

          <div class="mb20">
            <p class="mb20 bold">平台合同</p>
          </div>

          <div class="mt20">
            <el-button type="primary" @click="downloadPlatformContract">下载平台合同</el-button>
          </div>

          <div class="mt20 fr ac">
            <p class="fz14 bold mt20 mb20">我的合同</p>
          </div>
          <div>
            <up-load :limit="6" :file_list.sync="order_detail.contract_imgs"></up-load>
          </div>
        </div>

        <div class="fr jc ac mt40 mb40">
          <el-button style="width: 315px" type @click="rejectOrder">放弃接单</el-button>

          <div class="ml50">
            <el-button style="width: 315px" type="primary" @click="acceptOrder">确认接单</el-button>
          </div>
        </div>
      </div>
    </div>
    <footer-bar />

    <!--    弹窗-->

    <el-dialog :show-close="false" :visible.sync="crafts_show">
      <div slot="title" class="fr ac jsb head">
        <p class="fz14 black bold">配套工艺</p>
        <i class="el-icon-close fz14 cursor" @click="crafts_show = false"></i>
      </div>
      <el-table :data="crafts" tooltip-effect="dark" style="width: 100%">
        <el-table-column label="产品规格" header-align="center">
          <template slot-scope="scope">
            <p class="mb10">{{scope.row.craft_name}}</p>

            <el-select
              v-model="scope.row.select_id"
              placeholder="请选择"
              size="mini"
              @change="onCraftSelect(scope.row,scope.$index)"
            >
              <el-option
                v-for="item in scope.row.craftBeans"
                :key="item.craft_id"
                :label="item.craft_name"
                :value="item.craft_id"
              ></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="specification_price" label="数量" header-align="center" align="center">
          <template slot-scope="scope">
            <p class="mb30"></p>
            <el-input-number size="mini" v-model="scope.row.craft_count" :min="0"></el-input-number>
          </template>
        </el-table-column>
        <el-table-column prop="craft_price" label="价格" header-align="center" align="center">
          <template slot-scope="scope">
            <p class="mb30"></p>
            <p class="blue">￥{{scope.row.craft_price}}</p>
          </template>
        </el-table-column>
      </el-table>
      <!--      <div>-->
      <!--        <p class="fz14 mb10 mt10">其他技术要求</p>-->
      <!--        <el-input-->
      <!--            type="textarea"-->
      <!--            resize="none"-->
      <!--            :rows="5"-->
      <!--            style="width:50%;"-->
      <!--            v-model="craft_remark"-->
      <!--        ></el-input>-->
      <!--      </div>-->
    </el-dialog>
  </div>
</template>

<script>
import NavBar from "@/components/NavBar";
import SearchBar from "@/components/SearchBar";
import FooterBar from "@/components/FooterBar";
import Upload from "@/components/UploadImg";

export default {
  props: {},
  data() {
    return {
      //工艺弹窗
      crafts_show: false,
      //总的工艺列表
      crafts: [],

      //当前选择的商品id
      current_order_goods_id: "",

      order_detail: {},
      loading: false
    };
  },
  computed: {},
  mounted() {
    this.getOrderDetail();
    this.getCrafts();
  },
  methods: {
    //接受订单
    acceptOrder() {
      let param = {
        order_merchants_id: this.order_detail.order_merchants_id,
        contract_imgs: this.order_detail.contract_imgs.join(",")
      };

      if (!param.contract_imgs) {
        this.$message("请上传合同");
        return;
      }

      this.$confirm("是否接受此订单?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "success"
      })
        .then(() => {
          this.post("orderInterfaces/v1.0/merchantsAcceptOrder", param).then(
            res => {
              this.$message("接单成功");
              this.back();
            }
          );
        })
        .catch(() => {});
    },

    //拒绝订单
    rejectOrder() {
      this.$confirm("是否放弃此订单?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let param = {
            order_merchants_id: this.order_detail.order_merchants_id
          };
          this.post("orderInterfaces/v1.0/merchantsRefuseOrder", param).then(
            res => {
              this.$message("拒绝成功");
              this.back();
            }
          );
        })
        .catch(() => {});
    },

    //下载平台合同
    downloadPlatformContract() {
      window.open(this.order_detail.contract_url);
    },
    //保存工艺选择
    saveCraftChange() {
      console.log(this.crafts);

      let orderCraftBeans = [];
      this.crafts.forEach(item => {
        let obj = {
          order_craft_id: item.order_craft_id,
          craft_id: item.select_id,
          craft_count: item.craft_count
        };
        orderCraftBeans.push(obj);
      });

      this.order_detail.json.forEach(item => {
        if (this.current_order_goods_id == item.order_goods_id) {
          item.orderCraftBeans = orderCraftBeans;
        }
      });

      //  重新获取价格
      this.checkout();

      //重置工艺选择
      this.getCrafts();

      this.crafts_show = false;
    },
    //显示商品工艺列表
    onShowSelectCraft(order_goods_id) {
      this.current_order_goods_id = order_goods_id;
      let json = this.order_detail.json;
      let goods_crafts = [];
      json.forEach(item => {
        if (item.order_goods_id == order_goods_id) {
          goods_crafts = item.orderCraftBeans;
        }
      });

      //  选中  工艺列表的数据

      this.crafts.forEach(item => {
        item.craftBeans.forEach(item2 => {
          goods_crafts.forEach(item3 => {
            if (item2.craft_id == item3.craft_id) {
              item.select_id = Number(item3.craft_id);
              item.craft_count = item3.craft_count;
              item.craft_price = item3.craft_price;
              item.order_craft_id = item3.order_craft_id;
            }
          });
        });
      });
      this.crafts_show = true;
      console.log(this.crafts);
    },

    // 重新选择工艺
    onCraftSelect(row, index) {
      let crafts = this.crafts;
      crafts[index].craftBeans.forEach(el => {
        if (el.craft_id == crafts[index].select_id) {
          crafts[index].craft_price = el.craft_price;
        }
      });
      this.crafts = JSON.parse(JSON.stringify(crafts));
    },
    //获取工艺列表
    getCrafts() {
      this.post("goodsInterfaces/v1.0/getCrafts").then(res => {
        let arr = res.data;
        arr.forEach(el => {
          el.craft_count = 1;
          el.select_id = "";
        });
        this.crafts = arr;
      });
    },
    // 订单详情
    getOrderDetail() {
      this.post("orderInterfaces/v1.0/getOrderMerchantsDetail", {
        order_merchants_id: this.$route.query.order_merchants_id
      }).then(res => {
        let order = res.data;
        this.initConfirmForm(order);

        this.loading = true;
      });
    },
    //付款方式
    startProportionEnd(e) {
      let v = e.target.value;

      let max = 100 - this.order_detail.pay_ing_proportion;

      if (v > max) {
        this.$message("不得大于" + max);
        return;
      }
      this.order_detail.pay_end_proportion =
        100 -
        this.order_detail.pay_ing_proportion -
        this.order_detail.pay_start_proportion;
    },
    //付款方式
    ingProportionEnd(e) {
      let v = e.target.value;

      let max = 100 - this.order_detail.pay_start_proportion;

      if (v > max) {
        this.$message("不得大于" + max);
        return;
      }
      this.order_detail.pay_end_proportion =
        100 -
        this.order_detail.pay_ing_proportion -
        this.order_detail.pay_start_proportion;
    },

    checkout() {
      //提交订单
      let order_detail = this.order_detail;
      let param = {
        order_id: order_detail.order_id,
        contract_type: order_detail.contract_type,
        pay_start_proportion: order_detail.pay_start_proportion,
        pay_ing_proportion: order_detail.pay_ing_proportion,
        pay_end_proportion: order_detail.pay_end_proportion,
        order_service_price: order_detail.order_service_price,
        order_actual_price: order_detail.order_actual_price,
        pay_day: order_detail.pay_day,
        json: JSON.stringify(order_detail.json),
        address_id: order_detail.address_id,
        is_invoice: order_detail.is_invoice,
        invoice_id: order_detail.invoice_id,
        contract_platform_imgs: order_detail.contract_platform_imgs.join(","),
        is_summit: 0
      };

      this.post("orderInterfaces/v1.0/sellConfirmOrder", param).then(res => {
        let order = res.data;
        this.initConfirmForm(order);
      });
    },

    //提交
    submit() {
      if (!this.order_detail.order_service_price) {
        this.$message("请输入服务费");
        return;
      }
      if (!this.order_detail.contract_type) {
        this.$message("请选择合同类型");
        return;
      }
      if (
        this.order_detail.contract_type == 1 &&
        this.order_detail.contract_platform_imgs.length == 0
      ) {
        this.$message("请上传平台合同");
        return;
      }

      if (!this.order_detail.pay_start_proportion) {
        this.$message("请输入付款方式");
        return;
      }
      if (!this.order_detail.pay_ing_proportion) {
        this.$message("请输入付款方式");
        return;
      }
      if (!this.order_detail.pay_end_proportion) {
        this.$message("请输入付款方式");
        return;
      }
      if (!this.order_detail.pay_day) {
        this.$message("请输入货到付款天数");
        return;
      }

      //提交订单
      let order_detail = Object.assign({}, this.order_detail);
      let param = {
        order_id: order_detail.order_id,
        contract_type: order_detail.contract_type,
        pay_start_proportion: order_detail.pay_start_proportion,
        pay_ing_proportion: order_detail.pay_ing_proportion,
        pay_end_proportion: order_detail.pay_end_proportion,
        order_service_price: order_detail.order_service_price,
        order_actual_price: order_detail.order_actual_price,
        pay_day: order_detail.pay_day,
        json: JSON.stringify(order_detail.json),
        address_id: order_detail.address_id,
        is_invoice: order_detail.is_invoice,
        invoice_id: order_detail.invoice_id,
        contract_platform_imgs: order_detail.contract_platform_imgs.join(","),
        is_summit: 1
      };
      this.post("orderInterfaces/v1.0/sellConfirmOrder", param).then(res => {
        this.$message("提交成功");
        this.back();
      });
    },
    initConfirmForm(order) {
      this.order_detail = order;
      this.order_detail.order_id = order.order_id;
      this.order_detail.contract_type = order.contract_type;
      this.order_detail.pay_start_proportion =
        order.pay_start_proportion == "0.00" ? "" : order.pay_start_proportion;
      this.order_detail.pay_ing_proportion =
        order.pay_ing_proportion == "0.00" ? "" : order.pay_ing_proportion;
      this.order_detail.pay_end_proportion =
        order.pay_end_proportion == "0.00" ? 100 : order.pay_end_proportion;
      this.order_detail.order_service_price =
        order.order_service_price == "0.00" ? "" : order.order_service_price;
      this.order_detail.order_actual_price = order.order_total_price;
      this.order_detail.address_id = order.orderAddressBean.address_id;
      this.order_detail.is_invoice = order.is_invoice;
      this.order_detail.invoice_id = order.orderInvoiceBean.invoice_id;
      this.order_detail.contract_imgs = this.order_detail.contract_imgs
        ? order.contract_imgs.split(",")
        : [];

      this.order_detail.contract_platform_imgs = this.order_detail
        .contract_platform_imgs
        ? order.contract_platform_imgs.split(",")
        : [];

      //    工艺
      let craft = [];

      for (const goods of order.orderGoodsBeans) {
        if (goods.goods_type == 1) {
          let obj = {
            order_goods_id: goods.order_goods_id,
            orderCraftBeans: goods.orderCraftBeans
          };
          craft.push(obj);
        } else {
          let obj = {
            order_goods_id: goods.order_goods_id,
            orderCraftBeans: []
          };
          craft.push(obj);
        }
      }
      this.order_detail.json = craft;
    }
  },
  components: { NavBar, SearchBar, FooterBar, "up-load": Upload }
};
</script>

<style scoped lang="scss">
.order_detail {
  .main {
    width: 1200px;
    margin: 0 auto;
    padding: 20px 0;

    .nav {
      background-color: #fff;
      padding: 20px;
      margin-bottom: 20px;
    }

    .info_box {
      background-color: #fff;
      padding: 20px;

      .info {
        background-color: #fff;

        .order_list_item {
          &:nth-of-type(1) {
            width: 400px;
          }

          &:nth-of-type(2) {
            width: 130px;
          }

          &:nth-of-type(3) {
            width: 130px;
          }

          &:nth-of-type(4) {
            width: 130px;
          }

          &:nth-of-type(5) {
            width: 130px;
          }

          &:nth-of-type(6) {
            width: 130px;
          }

          &:nth-of-type(7) {
            width: 130px;
          }
        }

        .order-list {
          .order-item {
            border: 1px solid #e5e5e5;

            .top {
              background-color: #f0f6ff;
              padding: 14px;
            }

            .middle {
              border-bottom: 1px solid #e5e5e5;

              .order {
                .order_left {
                  border-right: 1px solid #e5e5e5;
                  border-bottom: 1px solid #e5e5e5;

                  &:last-child {
                    border-bottom: none;
                  }

                  .goods_img {
                    width: 80px;
                    height: 80px;
                  }
                }

                .operating {
                  p {
                    margin-top: 10px;

                    &:nth-of-type(1) {
                      margin-top: 0;
                    }
                  }
                }
              }
            }
          }
        }
      }

      .price_box {
        font-size: 14px;

        .price_item {
          padding: 0 20px;
          min-height: 50px;
          background-color: #f0f6ff;
          border-bottom: 1px solid #fff;

          .vip_order_imgs {
            width: 80px;
            height: 80px;
            margin-right: 10px;
          }
        }

        .pay_table {
          height: 100px;
          border: 1px solid #e5e5e5;

          .tr {
            height: 50px;
            border-bottom: 1px solid #e5e5e5;

            &:nth-of-type(2) {
              border-bottom: none;
            }

            .th {
              background-color: #f0f6ff;
              font-weight: 800;
            }

            .th,
            .td {
              font-size: 14px;
              text-align: center;
              line-height: 50px;
              height: 100%;
              border-right: 1px solid #e5e5e5;

              &:last-child {
                border-right: none;
              }
            }

            .td {
              width: 33.33%;
            }
          }
        }

        .contract_img {
          width: 150px;
          height: 150px;
          margin-right: 10px;
        }

        .receipt {
          width: 40%;
          border: 1px solid #e5e5e5;

          .top {
            padding: 20px;
            border-bottom: 1px solid #e5e5e5;
          }

          .bottom {
            padding: 30px 20px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/me/merchantsOrder/detail.vue